// External Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { DateConditionComponent } from './date-condition.component';


@NgModule({
    declarations: [
        DateConditionComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [DateConditionComponent]
})
export class DateConditionModule { }
